//#region 3rd party imports
import { createApp } from 'vue'
import router from './router'
//#endregion 3rd party imports

//#region Local imports
import App from './components/App.vue'

import DirectFeatureInfo from './components/DirectFeatureInfo.vue'

//#region Import sidebar panel components

import MapModulesList from './components/MapModulesList.vue'
import MapModuleInfo from './components/MapModuleInfo.vue'
import StandardModuleDetails from './components/StandardModuleDetails.vue'

//#region Import Raumplanung components
import RaumplanungMain from './mapModules/raumplanung/RaumplanungMain.vue'
import RaumplanungFeatureInfo from './mapModules/raumplanung/RaumplanungFeatureInfo.vue'
import RaumplanungFeaturesList from './mapModules/raumplanung/RaumplanungFeaturesList.vue'
import RaumplanungAttributeInfo from './mapModules/raumplanung/RaumplanungAttributeInfo.vue'

//#endregion Import Raumplanung components

import { sidebarPanelNames } from './sidebarPanelNames'

import SimpleGeodataMain from './mapModules/simpleGeodata/SimpleGeodataMain.vue'
import SimpleGeodataFeatureInfo from './mapModules/simpleGeodata/SimpleGeodataFeatureInfo.vue'

import IkmMain from './mapModules/ikm/IkmMain.vue'
import IkmFeatureInfo from './mapModules/ikm/IkmFeatureInfo.vue'

import WmsFeatureInfo from './mapModules/wms/WmsFeatureInfo.vue'

import RasterGeodataMain from './mapModules/rasterGeodata/RasterGeodataMain.vue'
import RasterGeodataQueryPanel from './mapModules/rasterGeodata/RasterGeodataQueryPanel.vue'


import StoryMapMainPanel from './mapModules/storymap/StoryMapMain.vue'



//#region Import help texts
import { registerAppHelpTexts } from './helpTexts'
//#endregion Import help texts

//#endregion Import sidebar panel components



//#region Import SCSS
// macOS-inspired theme (system font stack, Apple system blue accent,
// frosted vibrancy panels) modeled on the Modern Elegant theme.
/*
import 'gertrud/src/styles/theme-macos/theme-macos.css'
import 'gertrud/style.css'
import './styles/theme-macos/theme-macos.scss'


import 'gertrud/src/styles/theme-modern/theme-modern.css'
import 'gertrud/style.css'
import './styles/theme-modern/theme-modern.scss'
*/

import 'gertrud/src/styles/theme-mrn/theme-mrn.css'
import 'gertrud/style.css'
import './styles/theme-mrn/theme-mrn.scss'

//#endregion Import SCSS

//#endregion Local imports

const app = createApp(App)

app.use(router)




//#region register sidebar panel components. We need to do this because they are used as dynamic components, defined by map/layer configurations


// Register globally:


app.component(sidebarPanelNames.DIRECT_FEATURE_INFO, DirectFeatureInfo)

app.component(sidebarPanelNames.IKM_MAIN, IkmMain)
app.component(sidebarPanelNames.IKM_FEATURE_INFO, IkmFeatureInfo)
app.component(sidebarPanelNames.MAP_MODULE_INFO, MapModuleInfo)
app.component(sidebarPanelNames.MAP_MODULES_LIST, MapModulesList)
app.component(sidebarPanelNames.MAP_MODULE_INFO)

app.component(sidebarPanelNames.RASTER_GEODATA_TIME_SERIES, RasterGeodataMain)
app.component(sidebarPanelNames.RASTER_GEODATA_VALUE_QUERY, RasterGeodataQueryPanel)

app.component(sidebarPanelNames.RAUMPLANUNG_ATTRIBUTE_INFO, RaumplanungAttributeInfo)
app.component(sidebarPanelNames.RAUMPLANUNG_FEATURE_INFO, RaumplanungFeatureInfo)
app.component(sidebarPanelNames.RAUMPLANUNG_FEATURES_LIST, RaumplanungFeaturesList)
app.component(sidebarPanelNames.RAUMPLANUNG_MAIN, RaumplanungMain)


app.component(sidebarPanelNames.SIMPLE_GEODATA_MAIN, SimpleGeodataMain)
app.component(sidebarPanelNames.SIMPLE_GEODATA_FEATURE_INFO, SimpleGeodataFeatureInfo)

app.component(sidebarPanelNames.STANDARD_MODULE_MAIN, StandardModuleDetails)
app.component(sidebarPanelNames.STORYMAP_MAIN, StoryMapMainPanel)


app.component(sidebarPanelNames.WMS_FEATURE_INFO, WmsFeatureInfo)
//#endregion register sidebar panel components. We need to do this because they are used as dynamic components, defined by map/layer configurations


// Register application help texts
registerAppHelpTexts()

app.mount('#app')
